import base from "@/fstore";
import User from "@/fstore/collections/User";
import Company from "@/fstore/collections/Company";
import WordItNicely from "../misc/WordItNicely";

const auth = base.authentication;

const isLoggedIn = () => {
  return auth.currentUser ? true : false;
};

const currentUser = () => {
  return auth.currentUser;
};

//returns the base redirect URL for the currentUser
const getRedirectURL = async () => {
  if (!auth.currentUser)
    return { name: 'home' }

  const user = await User.getById(auth.currentUser.uid);

  switch (user.role) {
    case "candidate":
      return user.setup ? { name: "userProfile" } : { name: "setupUser", params: { id: auth.currentUser.uid } };

    case "company-owner":
      const company = await Company.getByUserId(user.uid);
      return user.setup ? { name: "companyJobs", query: {id: company.uid} } : { name: "companySetup" };

    case "admin":
      return { name: "adminDashboard" };

    default:
      return { name: "home" };
  }
};

const login = async credentials => {
  try {
    const response = await auth.signInWithEmailAndPassword(
      credentials.email,
      credentials.password
    );

    // fetch the user
    const user = await User.getById(response.user.uid);

    if (!user.verified) {
      return {
        code: "auth/user-not-verified",
        message:
          "This account has not been verified. Please verify your email before logging in."
      };
    }

    // get the redirect URL for the user
    const redirectURL = await getRedirectURL();
    return { code: 200, data: user, redirectURL };
  } catch (error) {
    console.error(error);
    return error;
  }
};

const logout = async () => {
  await auth.signOut();
};

// we eventually need to override the firebase password reset email handler with a custom one
const resetPassword = async (email) => {
  try{
    await auth.sendPasswordResetEmail(email);
    return null;
  }catch(error){
    return WordItNicely(error.code);
  }
}

export default {
  ref: auth,
  login,
  logout,
  resetPassword,
  isLoggedIn,
  currentUser,
  getRedirectURL
};
